module.exports = __webpack_public_path__ + "6f8152140597b9db38710541054ba92e.MP3";